/**
 * @fileoverview Defines the `Navbar` React component, which renders the application's navigation bar. It utilizes `NavbarProps` and the `useAuth` hook to conditionally display navigation links based on authentication status. The `Navbar` component provides routing to various application sections.
 */

import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth' // import useAuth
import '../styles/components/Navbar.css'

interface NavbarProps {
  pageName?: string
  pageNameLink?: string
}

export const Navbar: React.FC<NavbarProps> = ({ pageName, pageNameLink }) => {
  // get auth state
  const { user } = useAuth()

  return (
    <header className="header">
      <div className="logo">
        <Link to="/" className="logo">
          Ref.
        </Link>
        {pageName && (
          <span className="logo page-title">
            {' / '}
            {pageNameLink ? (
              <Link to={pageNameLink} className="logo">
                {pageName}
              </Link>
            ) : (
              pageName
            )}
          </span>
        )}
      </div>
      <nav>
        <a href="/blog" className="link">
          blog
        </a>

        <Link to="/demo" className="link">
          demo
        </Link>
        <Link to="/mcp" className="link">
          mcp
        </Link>
        {user ? (
          <Link to="/dashboard" className="link">
            dashboard
          </Link>
        ) : (
          <Link to="/signup" className="link">
            sign up
          </Link>
        )}
      </nav>
    </header>
  )
}
